var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoetstoolBroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.136,
    viewBox: "0 0 14 13.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.364 2.166a.6.6 0 0 0-.853 0l-2.842 2.841-.191-.187a2.987 2.987 0 0 0-3.835-.286 9.912 9.912 0 0 1-2.712 1.449l-1.237.363A3 3 0 0 0 .837 7.918a2.966 2.966 0 0 0-.082 2.4 7.725 7.725 0 0 0 7.225 4.81h.551a.6.6 0 0 0 .345-.109 9.119 9.119 0 0 0 4-6.09 3 3 0 0 0-.867-2.609l-.477-.468 2.832-2.832a.6.6 0 0 0 0-.853zM8.335 13.917h-.357a6.74 6.74 0 0 1-2.57-.505h.007a6.887 6.887 0 0 0 2.6-2.267l.309-.454a.6.6 0 1 0-1-.679l-.309.454a5.688 5.688 0 0 1-2.143 1.869l-.746.376a6.416 6.416 0 0 1-1.541-1.533 6.934 6.934 0 0 0 2.61-1.593.6.6 0 0 0-.843-.863 5.736 5.736 0 0 1-2.374 1.384c-.036-.081-.076-.159-.109-.242a1.733 1.733 0 0 1 .051-1.42A1.8 1.8 0 0 1 3.031 7.5l1.237-.36a9.165 9.165 0 0 0 2.044-.947l4.721 4.6a8.465 8.465 0 0 1-2.7 3.126zm3.352-5.179a7.409 7.409 0 0 1-.184.827l-4.158-4.05a1.8 1.8 0 0 1 1.047-.338 1.773 1.773 0 0 1 1.243.506l1.532 1.5a1.8 1.8 0 0 1 .52 1.559z",
    transform: "translate(-.541 -1.99)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoetstoolBroom);
export default __webpack_public_path__ + "static/media/poetstool-broom.e633277fd91a9c0117089889e1da4b6f.svg";
export { ForwardRef as ReactComponent };